
export default {
  name: 'BrandBannerReviews',
  props: {
    rating: {
      type: Number,
      default: 0,
    },
    count: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    starStyle() {
      return {
        fullStarColor: this.isBoutiquePage ? this.$cp.black : this.$cp.black,
        emptyStarColor: this.$cp.transparent,
        starWidth: 18,
        starHeight: 18,
      };
    },
    ratingCount() {
      return this.count.toLocaleString('en-US');
      // return `${this.count.toLocaleString('en-US')} ${this.count === 1
      //   ? 'Review' : 'Reviews'}`;
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    toggleReviews() {
      this.$emit('toggle-reviews', true);
    },
  },
};
